module.exports = __webpack_public_path__ + "static/step_2_4-87a1e9db63aadb122a40b438979324ad.svg";